/**
 * Placeholder block for content that is still loading. Give it the final
 * dimensions (via className) so the page does not shift when data arrives.
 * Decorative: hide from assistive tech; announce loading elsewhere.
 */
export default function Skeleton({ className = 'h-4 w-full' }) {
  return (
    <div aria-hidden="true" className={`rounded-sm bg-surface-alt motion-safe:animate-pulse ${className}`} />
  );
}
